<template>
  <div class="admin-records">
    <div>
      <ul>
        <li :class="{mobile: mobile}">
          <p>{{ record.rank }}</p>
          <h4>{{ record.displayName }}</h4>
          <p>{{ record.grade }}</p>
          <div class="icontain">
            <PencilAltIcon
              class="icon"
              @click="toggleEditModal"
            />
            <TrashIcon
              class="icon"
              @click="doDelete"
            />
          </div>
        </li>
      </ul>
      <div v-if="showEditModal">
        <EditModal
          :record="record"
          @close="toggleEditModal"
        />
      </div>
      <confirm-dialogue ref="confirmDialog"></confirm-dialogue>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import EditModal from '@/components/EditModal.vue'
import useDeleteUser from '@/composables/useDeleteUser'
import { onMounted } from '@vue/runtime-core'
import { PencilAltIcon, TrashIcon } from '@heroicons/vue/outline'
import ConfirmDialogue from '../ConfirmDialogue.vue'

export default {
  components: { PencilAltIcon, TrashIcon, EditModal, ConfirmDialogue },
  props: ['record'],
  setup (props, context) {
    const mobile = ref(false)
    const toast = ref(false)
    const confirmDialog = ref(null)
    const ok = ref(null)
    const showEditModal = ref(false)
    const windowWidth = ref(null)

    // deleteUser
    const { error, deleteUserCredential } = useDeleteUser()
    const deleteUser = async () => {
      await deleteUserCredential({ id: props.record.uid })
      if (!error.value) {
        toast.value = true
      }
      context.emit('toasts')
    }

    const toggleEditModal = () => {
      showEditModal.value = !showEditModal.value
    }

    const doDelete = async () => {
      ok.value = await confirmDialog.value.show({
        title: 'Delete Learner Record',
        message: `Are you sure you want to delete ${props.record.displayName}'s record? It cannot be undone.`,
        okButton: 'Delete',
        cancelButton: 'NO'
      })
      // If you throw an error, the method will terminate here unless you surround it wil try/catch
      if (ok.value) {
        await deleteUser()
      }
    }

    const handleview = () => {
      windowWidth.value = window.innerWidth
      if (windowWidth.value <= 750) {
        mobile.value = true
        return
      }
      mobile.value = false
    }

    onMounted(() => {
      handleview()
      window.addEventListener('resize', handleview)
    })
    return { mobile, doDelete, toggleEditModal, showEditModal, confirmDialog }
  }
}
</script>

<style>
.admin-records {
  background: #fff;
}
.admin-records div {
  background: white;
  border: 1px solid pink;
  padding: 5px;
}
.admin-records li {
  list-style-type: none;
  background: #eee;
  padding: 10px 20px;
  margin: 5px auto;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.admin-records .icontain {
  background: transparent;
  border: none;
  display: flex;
  justify-content: flex-end;
  width: 100px;
}
.admin-records li.mobile .icontain {
  flex-direction: column;
}
.admin-records li.mobile .icon {
  margin-top: 10px;
}
.admin-records li.mobile {
  display: flex;
  flex-direction: column;
}
.admin-records .icon {
  max-width: 17px;
  cursor: pointer;
  margin-left: 25px;
}
.admin-records p, h3, ul {
    padding: 0;
    margin: 0;
}
</style>
